module.exports = __webpack_public_path__ + "img/weibo.d66fc3d5.png";